import { appMessageController } from './AppMessageController';
import { MobileDetector } from './MobileDetector';
export class Vibrations {
    active = false;
    available = false;
    checkAvailability() {
        if (!MobileDetector.isMobile())
            return;
        appMessageController.sendMessage('{"event": "canVibrate"}');
    }
    vibrate(ms = 100) {
        if (!this.active || !this.available)
            return;
        appMessageController.sendMessage(`{"event": "vibrate", "timeMs": ${ms}}`);
    }
}
export const vibrations = new Vibrations();
//# sourceMappingURL=Vibrations.js.map